/* eslint-disable react/no-danger */
import React from 'react';
import _ from 'lodash';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from './layouts/BoxedContainer';
import Sprites from '../components/Sprites';

function CtaItem({ data, index }) {
  const icon = _.get(data, 'content.icon', '');
  const title = _.get(data, 'content.title', '');
  const text = _.get(data, 'content.text', '');
  const cta = _.get(data, 'content.cta', {});
  const isRegulations =
    typeof window !== 'undefined' && _.includes(window.location.pathname, 'regulations');

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.3 * (index + 1), delay: 0.5 }}
      className="">
      <div className="flex flex-col pt-7 pb-8 items-center gap-5 h-full justify-between">
        <div className="flex flex-col items-center gap-4">
          <Sprites name={icon} className="w-auto h-22.5 child:stroke-red" />
          <h3 className="text-clamp16to18
          ltr:!font-URWDINMedium rtl:font-GESSTwoDWTCMedium leading-1.5 !m-0 text-center text-red">
            {title}
          </h3>
          <p
            className="text-clamp14to16 leading-1.5 !m-0 text-center font-DINRegular
          text-[#4D4D4D]">
            {text}
          </p>
        </div>
        {_.isEmpty(cta) || (
          <a
            href={cta.url}
            target={cta.target}
            className={`get-it-touch-${index+1}-cta text-white bg-red hover:bg-[#B53B50] h-10
            md:h-[51px] md:py-4 px-5 md:px-7 flex w-fit gap-6
            rtl:pt-[2px] ltr:pt-[3px] ltr:md:pt-5 rtl:md:pt-4.5
            rounded-full uppercase ltr:leading-[36px] rtl:leading-[38px] 
            md:ltr:leading-1.125 md:rtl:leading-1.5
            tracking-widest text-center max-w-full !font-URWDINBold
            text-[11px] lg:text-[14px]`}>
            <span
              className='w-full overflow-hidden text-ellipsis whitespace-nowrap inline-block !font-URWDINBold' 
              dir='ltr'>
              {cta.name}
            </span>
          </a>
        )}
      </div>
    </motion.div>
  );
}

function CardItem({ data, keyIndex, dataClass }) {
  const title = _.get(data, 'content.titleHtml', '');
  const text = _.get(data, 'content.textHtml', '');
  const cta = _.get(data, 'content.cta', '');
  const image = _.get(data, 'content.image', '');
  const mobileImage = _.get(data, 'content.mobileImage', '');
  const isRegulations =
    typeof window !== 'undefined' && _.includes(window.location.pathname, 'regulations');
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.3 * (keyIndex + 1), delay: 0.6 }}
      className={`col-span-6 md:col-span-3 lg:col-span-6 flex flex-col justify-between
      ${isRegulations ? 'bg-ghostWhite' : 'bg-white'}`}>
      <div
        className={`flex flex-col items-center justify-between h-full
      ${
        isRegulations
          ? 'bg-ghostWhite gap-5 md:gap-6 pb-8 pt-7 md:py-10 px-[15px] md:px-[83px]'
          : 'pt-9 pb-10 px-4 lg:px-[83px] gap-5'
      }
      `}>
        <div className="flex flex-col items-center gap-2">
          <div
            className="child:text-clamp20to25 
            child:ltr:!font-URWDINMedium child:rtl:!font-GESSTwoDWTCMedium 
            child:leading-[1.6] 
            last:child:!m-0 child:text-center child:text-[#4A4A4A]"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          {_.isEmpty(text) || (
            <div
              className="child:text-clamp12to16 
              child:ltr:!font-URWDINRegular child:rtl:!font-GESSTwoDWTCLight 
              child:leading-[1.6] 
          last:child:!m-0 child:text-center child:text-[#4A4A4A]"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          )}
        </div>
        {_.isEmpty(cta) ||
          (dataClass !== 'no-downloads' ? (
            <a
              href={cta.url}
              target={cta.target}
              download
              className="regulations-download-cta text-white bg-red h-10 md:h-[51px] 
              md:py-3 px-12 md:px-7 inline-flex w-fit gap-3 md:gap-4 
            rounded-full uppercase tracking-widest font-URWDINBold 
            text-[11px] md:text-[12px] lg:text-[14px] 
            items-center
            hover:bg-[#B53B50]">
              <span className='flex items-center ltr:pt-[4px]'>{cta.name}</span>
              <Sprites name="download" />
            </a>
          ) : (
            <a
              href={cta.url}
              target={cta.target}
              className="text-white bg-red h-10 md:h-[51px] 
              md:py-3 px-12 md:px-7 inline-flex w-fit gap-6 
            rounded-full uppercase tracking-widest font-URWDINBold 
            text-[11px] md:text-[12px] lg:text-[14px] 
            items-center
            hover:bg-[#B53B50]">
              <span className='flex items-center ltr:pt-[4px]'>{cta.name}</span>
            </a>
          ))}
      </div>
      {_.isEmpty(image) || (
        <LazyLoadImage
          src={image.url}
          alt={title}
          className="w-full !max-h-64 object-cover md:!block hidden"
          wrapperClassName="md:!block hidden"
        />
      )}
      {_.isEmpty(mobileImage)
        ? _.isEmpty(image) || (
            <LazyLoadImage
              src={image.url}
              alt={title}
              width="100%"
              effect="blur"
              wrapperClassName="md:!hidden !block"
              className="w-full h-full object-cover max-h-[150px] 
              md:max-h-[472px] md:!hidden !block"
            />
          )
        : _.isEmpty(mobileImage) || (
            <LazyLoadImage
              src={mobileImage.url}
              alt={title}
              width="100%"
              effect="blur"
              wrapperClassName="md:!hidden !block"
              className="w-full h-full object-cover max-h-[150px] 
              md:max-h-[472px] md:!hidden !block"
            />
          )}
    </motion.div>
  );
}

function FreeZoneGetInTouchTwoCol({ id, data }) {
  const title = _.get(data, 'title', '');
  const text = _.get(data, 'text', '');
  const cssClass = _.get(data, 'cssClass', '');
  const ctaItems = _.get(data, 'ctaItems', []);
  const cardItems = _.get(data, 'cardItemsField', []);
  const isRegulations =
    typeof window !== 'undefined' && _.includes(window.location.pathname, 'regulations');
  // console.log("data", data);

  return (
    <section
      id={id}
      className={`${cssClass === 'no-downloads' ? 'pt-10 lg:pt-24 pb-12.5 lg:pb-[100px]' : 'py-12.5'} 
    ${isRegulations ? 'bg-white' : 'bg-desertStorm'}`}>
      <BoxedContainer>
        <div className="w-full grid grid-cols-6 lg:grid-cols-12 gap-4 md:gap-[30px]">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.4 }}
            viewport={{ once: true }}
            className="col-span-6 lg:col-span-12 flex flex-col items-center gap-5">
            <div
              className="child:text-clamp20to40 
              child:ltr:!font-URWDINMedium child:rtl:!font-GESSTwoDWTCMedium
              child:leading-[1.3] last:child:!m-0
              child:text-center child:text-[#231F20]"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <div className="py-px bg-red w-10 lg:w-12.5" />
            <div
              className="child:text-clamp12to18 
              child:ltr:!font-URWDINRegular child:rtl:!font-GESSTwoDWTCLight 
              child:leading-1.4
              last:child:!m-0 child:text-center child:text-[#4D4D4D] md:pt-[10px]"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </motion.div>
          {_.isEmpty(ctaItems) || (
            <div className="col-span-6 lg:col-span-12 grid grid-cols-1 lg:grid-cols-12 lg:pb-10">
              <div
                className="grid grid-cols-1 md:grid-cols-3 lg:col-span-12 
              md:gap-10 lg:gap-15">
                {_.map(ctaItems, (cta, index) => (
                  <CtaItem index={index} data={cta} />
                ))}
              </div>
            </div>
          )}

          <div
            className={`col-span-6 lg:col-span-12 grid grid-cols-6 lg:grid-cols-12 
          gap-10 lg:gap-8 ${isRegulations ? 'md:pt-[30px]' : ''}`}>
            {_.map(cardItems, (card, index) => (
              <CardItem keyIndex={index} data={card} dataClass={cssClass} />
            ))}
          </div>
        </div>
      </BoxedContainer>
    </section>
  );
}

export default FreeZoneGetInTouchTwoCol;
